import { render } from "./SocialMediaDisclaimer.vue?vue&type=template&id=4e6ae833&scoped=true"
import script from "./SocialMediaDisclaimer.vue?vue&type=script&lang=js"
export * from "./SocialMediaDisclaimer.vue?vue&type=script&lang=js"

import "./SocialMediaDisclaimer.vue?vue&type=style&index=0&id=4e6ae833&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e6ae833"]])

export default __exports__